export default "__VITE_ASSET__Dsxjxjjn__"